// extracted by mini-css-extract-plugin
export default {"mainBox":"ContinueLink-module--mainBox--zrZfV","mainBox__label":"ContinueLink-module--mainBox__label--M7wI5"};